import React from 'react';
import FadeIn from './FadeIn';

export default function Problem() {
  return (
    <section className="py-20 bg-slate-50 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <FadeIn className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&q=80&w=1000" 
                alt="Stress over finances" 
                className="w-full aspect-[4/3] object-cover"
              />
              <div className="absolute inset-0 bg-slate-900/20"></div>
            </div>
          </FadeIn>

          <FadeIn className="order-1 lg:order-2">
            <h2 className="text-3xl font-bold text-slate-900 mb-8 leading-tight">We know the feeling.</h2>
            <div className="space-y-6 text-lg text-slate-700 leading-relaxed">
              <p>
                The knot in your stomach before logging into your bank app. The silent dread when the mail arrives. The sheer exhaustion of moving money around just to make it to Friday.
              </p>
              <p>
                When you're living paycheck-to-paycheck, money isn't just numbers. It's anxiety. It's feeling behind. It's the shame of another $35 overdraft fee when you were just trying to buy groceries.
              </p>
              <div className="p-6 bg-white rounded-xl shadow-sm border border-slate-200 mt-8">
                <p className="font-semibold text-slate-900 mb-2">Here is the truth:</p>
                <p className="text-base">
                  You are not "bad with money." You are simply overwhelmed, and you don't have a reliable, visible system that matches your reality. You don't need a lecture on skipping lattes. You need a lifeline.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}